import { render } from "./doc-link.vue?vue&type=template&id=eeeffb18"
import script from "./doc-link.vue?vue&type=script&lang=js"
export * from "./doc-link.vue?vue&type=script&lang=js"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__